import { CHANGE_USERINFO } from '@/store/mutation-types';
import { UserState, UserInfo } from '@/types/root';
import { Commit } from 'vuex';
import { getUserInfo } from '@/services/user';

const initState: UserState = {
  isLogin: false,
  userInfo: {
    id: -1,
    user_name: '',
    avatar: '',
    tel: '',
    email: '',
    work_state: ''
  }
};

const actions = {
  async getUserInfo(context: { commit: Commit; state: UserState }) {
    try {
      const res = await getUserInfo<UserInfo>();
      if (res.code === 0) {
        const payload = {
          ...res.data
        };
        context.commit(CHANGE_USERINFO, payload);
      }
    } catch (error) {
      // TODO send error alert
    }
  },
  setUserInfo(context: { commit: Commit; state: UserState }, payload: UserInfo) {
    context.commit(CHANGE_USERINFO, payload);
  }
};

const mutations = {
  [CHANGE_USERINFO]: (state: UserState, payload: UserInfo) => {
    state.isLogin = true;
    state.userInfo = payload;
    window.localStorage.setItem('mobileUserInfo', JSON.stringify(payload));
  }
};

const getters = {
  isLogin: (state: UserState) => state.isLogin,
  userInfo: (state: UserState) => state.userInfo,
  isUserProfileAvailable: (state: UserState) => {
    if (state.userInfo.work_state === 'study') {
      if (!(state.userInfo.degree && state.userInfo.study_college && state.userInfo.study_major)) {
        return false;
      }
    } else if (state.userInfo.work_state === 'job') {
      if (!(state.userInfo.job_company && state.userInfo.job_position)) {
        return false;
      }
    } else {
      return false;
    }
    return !!(state.userInfo.real_name && state.userInfo.email && state.userInfo.tel);
  }
};

export default {
  state: initState,
  mutations,
  actions,
  getters
};
